/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export class ProjectDataActionsNames {
  static GetParamCategory = (): string => '[ProjectData] GetParamCategory';
  static GetParamCategorySuccess = (): string => '[ProjectData] GetParamCategory Success';

  static InitializeAddProjectParameters = (): string => '[ProjectData] InitializeAddProjectParameters';

  static InitializeAddProjectParametersSuccess = (): string => '[ProjectData] InitializeAddProjectParameters Success';

  static GetDefinitionGroupParameters = (): string => '[ProjectData] GetDefinitionGroupParameters';
  static GetDefinitionGroupParametersSuccess = (): string => '[ProjectData] GetDefinitionGroupParameters Success';

  static GetBuiltInGroupParameters = (): string => '[ProjectData] GetBuiltInGroupParameters';
  static GetBuiltInGroupParametersSuccess = (): string => '[ProjectData] GetBuiltInGroupParametersSuccess';
}
